import styles from "../styles/FeaturedMenu.module.css";
import MenuCard from "./MenuCard";

const menuItems = [

  {

    title: "Signature Burger",

    price: "€15",

    image:

      "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&w=800&q=80",

    description: "Premium beef, cheddar, bacon & house sauce."

  },

  {

    title: "Grilled Salmon",

    price: "€21",

    image:

      "https://images.unsplash.com/photo-1467003909585-2f8a72700288?auto=format&fit=crop&w=800&q=80",

    description: "Fresh salmon served with seasonal vegetables."

  },

  {

    title: "Steak",

    price: "€28",

    image:

      "https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&w=800&q=80",

    description: "Tender grilled steak cooked to perfection."

  },

  {

    title: "Cocktail Special",

    price: "€12",

    image:

      "https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&w=800&q=80",

    description: "Fresh ingredients with premium spirits."

  },

  {

    title: "Pasta Alfredo",

    price: "€17",

    image:

      "https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?auto=format&fit=crop&w=800&q=80",

    description: "Creamy parmesan sauce with grilled chicken."

  },

  {

    title: "Chocolate Dessert",

    price: "€9",

    image:

      "https://images.unsplash.com/photo-1563805042-7684c019e1cb?auto=format&fit=crop&w=800&q=80",

    description: "Rich chocolate dessert with vanilla ice cream."

  }

];

function FeaturedMenu() {
  return (
    <section id="menu" className={styles.menu}>
      <div className={styles.container}>
        <span className={styles.subtitle}>OUR MENU</span>

        <h2>Chef's Recommendations</h2>

        <p className={styles.description}>
          A selection of customer favorites prepared with fresh ingredients and
          served with passion.
        </p>

        <div className={styles.grid}>
          {menuItems.map((item) => (
            <MenuCard
              key={item.title}
              item={item}
            />
          ))}
        </div>

        <a href="#contact" className={styles.button}>
          View Full Menu
        </a>
      </div>
    </section>
  );
}

export default FeaturedMenu;